import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Injectable, inject, DestroyRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "@progress/kendo-angular-l10n";
import { HelpersService } from "../helpers-service/helpers.service";

@Injectable()
export class KendoMessageService extends MessageService {
    private readonly destroyRef = inject(DestroyRef);
    translateService = inject(TranslateService);
    helpersService = inject(HelpersService);

    constructor() {
        super();

        this.translateService.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.notify(false);
        });
    }

    public get(key: string): string {
        if (this.helpersService.getLang() === "fr-CA") {
            const translated = this.translateService.instant(key);
            if (translated === key) {
                return undefined;
            } else {
                return translated;
            }
        } else {
            return undefined;
        }
    }
}
